import {Model} from 'vue-mc';

/**
 * CloneModel model
 */
export default class LayoutModel extends Model {


    // Default attributes that define the "empty" state.
    defaults() {
        return {
            layout_id: "",
            client_id: "",
            name: "",
            wrap_in_tag: "",
            wrap_tag_options: "",
            width: "",
            border: "",
            cellspacing: "",
            cellpadding: "",
            style: "",
            default: "",
            table_id: ""
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/layoutModel.js